import { BoxTitles } from "@boxes/BoxTitles";
import { Button, Checkbox, Drawer, Select } from "@components";
import { BaseCurrencyInput } from "@components/CurrencyInput/BaseCurrencyInput";
import classNames from "classnames/bind";

import styles from "@styles/forms-flow/filtered-audience.module.scss";
import triggerStyles from "@styles/forms-flow/trigger.module.scss";

import { Case, Default, Switch } from "@components/control-statements";
import React from "react";

const cssTrigger = classNames.bind(triggerStyles);

export class SpecificClimateConditionalForm extends React.Component {
  state = {
    payload: null,
    collapsed: null,
  };

  get defaultPayload() {
    return {
      climate: {
        temperature: { active: false, max: null, min: null },
        rain: { active: false, max: null, min: null },
        moisture: { active: false, max: null, min: null },
      },
      weather: [],
      time: {
        from: "",
        to: "",
      },
    };
  }

  componentDidMount() {
    const { node } = this.props;
    this.setState({
      payload: {
        ...this.defaultPayload,
        ...node.data,
      },
    });
  }

  setPayloadKeyValue(key, value) {
    const { node, onChange } = this.props;
    const { payload } = this.state;
    this.setState({
      payload: {
        ...payload,
        [key]: Array.isArray(payload[key])
          ? value
          : {
              ...(payload[key] || {}),
              ...value,
            },
      },
    });

    onChange && onChange({ ...node, data: { ...node.data, ...payload } });
  }

  setClimatePayloadKeyValue(key, value) {
    const { node, onChange } = this.props;
    const { payload } = this.state;

    this.setState({
      payload: {
        ...payload,
        climate: {
          ...(payload?.climate || {}),
          [key]: {
            ...(payload?.climate[key] || {}),
            ...value,
          },
        },
      },
    });

    onChange && onChange({ ...node, data: { ...node.data, ...payload } });
  }

  getHoraries() {
    const horaries = [];

    for (let i = 8; i <= 22; i++) {
      horaries.push({
        value: `${String(i).padStart(2, "0")}:00`,
        label: `${String(i).padStart(2, "0")}:00`,
      });
    }

    for (let i = 0; i <= 6; i++) {
      horaries.push({
        value: `${String(i).padStart(2, "0")}:00`,
        label: `${String(i).padStart(2, "0")}:00`,
      });
    }

    return horaries;
  }

  getTimeIntervalOptionsFrom() {
    const filteredHoraries = this.getHoraries().filter(
      (e) => e.value !== this.state.payload?.time?.to
    );

    return filteredHoraries;
  }

  getTimeIntervalOptionsTo() {
    const filteredHoraries = this.getHoraries().filter(
      (e) => e.value !== this.state.payload?.time?.from
    );

    return filteredHoraries;
  }

  renderTemperature() {
    const { temperature } = this.state.payload?.climate || { temperature: {} };

    return (
      <>
        <p className={styles.label}>
          Defina o valor mínimo e máximo da temperatura
        </p>
        <div className="d-flex align-center mt-25">
          <BaseCurrencyInput
            className="w-100 mr-15"
            suffix={" °"}
            prefix={""}
            design="two"
            precision={0}
            label="Temp. mín."
            value={temperature.min}
            onChange={(value) => {
              this.setClimatePayloadKeyValue("temperature", {
                min: value,
              });
            }}
          />
          <BaseCurrencyInput
            className="w-100"
            suffix={" °"}
            prefix={""}
            design="two"
            precision={0}
            label="Temp. máx."
            value={temperature.max}
            onChange={(value) => {
              this.setClimatePayloadKeyValue("temperature", {
                max: value,
              });
            }}
          />
        </div>
      </>
    );
  }

  renderMoisture() {
    const { moisture } = this.state.payload?.climate || { moisture: {} };

    return (
      <>
        <p className={styles.label}>Defina o mínimo e máximo de umidade</p>
        <div className="d-flex align-center mt-25">
          <BaseCurrencyInput
            className="w-100 mr-15"
            suffix={" %"}
            prefix={""}
            design="two"
            precision={0}
            label="Umidade mín."
            max="5"
            value={moisture?.min}
            onChange={(value) => {
              this.setClimatePayloadKeyValue("moisture", {
                min: value,
              });
            }}
          />
          <BaseCurrencyInput
            className="w-100"
            suffix={" %"}
            prefix={""}
            design="two"
            precision={0}
            label="Umidade máx."
            max="5"
            value={moisture?.max}
            onChange={(value) => {
              this.setClimatePayloadKeyValue("moisture", {
                max: value,
              });
            }}
          />
        </div>
      </>
    );
  }

  renderRain() {
    const { rain } = this.state.payload?.climate || { rain: {} };

    return (
      <>
        <p className={styles.label}>
          Defina o mínimo e máximo de probabilidade de chuva
        </p>
        <div className="d-flex align-center mt-25">
          <BaseCurrencyInput
            className="w-100 mr-15"
            suffix={" %"}
            prefix={""}
            design="two"
            precision={0}
            label="Prob. mín."
            max="5"
            value={rain?.min}
            onChange={(value) => {
              this.setClimatePayloadKeyValue("rain", {
                min: value,
              });
            }}
          />
          <BaseCurrencyInput
            className="w-100"
            suffix={" %"}
            prefix={""}
            design="two"
            precision={0}
            label="Prob. max."
            max="5"
            value={rain?.max}
            onChange={(value) => {
              this.setClimatePayloadKeyValue("rain", {
                max: value,
              });
            }}
          />
        </div>
      </>
    );
  }

  renderMainPage() {
    const { climate, weather, time } = this.state.payload || {
      climate: {},
      weather: [],
      time: {
        from: null,
        to: null,
      },
    };

    const toggleWeather = (alias) => {
      if (weather?.includes(alias)) {
        this.setPayloadKeyValue(
          "weather",
          weather?.filter((f) => f != alias)
        );
      } else {
        this.setPayloadKeyValue("weather", [...weather, alias]);
      }
    };

    const setTimeRange = (type, value) => {
      this.setPayloadKeyValue("time", { [type]: value.target.value });
    };

    return (
      <div className={triggerStyles.triggerForm}>
        <p className={styles.label}>Quando a condição climática estiver</p>
        <div className={triggerStyles.options}>
          <CheckCard
            title="Com temperatura entre"
            iconCls="fal fa-temperature-half"
            isSelected={climate?.temperature?.active}
            onCheck={() => {
              this.setClimatePayloadKeyValue("temperature", {
                active: !climate?.temperature?.active,
              });
            }}
            onOpen={() => this.setState({ selectedItem: "temperature" })}
          />
          <CheckCard
            title="Com a umidade entre"
            iconCls="fal fa-droplet"
            isSelected={climate?.moisture?.active}
            onCheck={() =>
              this.setClimatePayloadKeyValue("moisture", {
                active: !climate?.moisture?.active,
              })
            }
            onOpen={() => this.setState({ selectedItem: "moisture" })}
          />
          <CheckCard
            title="Com a probabilidade de chuva entre"
            iconCls="fal fa-cloud-rain"
            isSelected={climate?.rain?.active}
            onCheck={() =>
              this.setClimatePayloadKeyValue("rain", {
                active: !climate?.rain?.active,
              })
            }
            onOpen={() => this.setState({ selectedItem: "rain" })}
          />
        </div>
        <div className={styles.hairlineB} />
        <p className={styles.label}>Quando a condição climática estiver</p>
        <div className={triggerStyles.options}>
          <CheckCardWeather
            title="Ensolarado"
            iconCls="fal fa-sun"
            isSelected={weather?.includes("CLEAR")}
            onCheck={() => toggleWeather("CLEAR")}
          />
          <CheckCardWeather
            title="Parcialmente nublado"
            iconCls="fal fa-cloud-sun"
            isSelected={weather?.includes("PARTLY_CLOUDY")}
            onCheck={() => toggleWeather("PARTLY_CLOUDY")}
          />
          <CheckCardWeather
            title="Nublado"
            iconCls="fal fa-cloud"
            isSelected={weather?.includes("CLOUDY")}
            onCheck={() => toggleWeather("CLOUDY")}
          />
          <CheckCardWeather
            title="Chovendo"
            iconCls="fal fa-cloud-rain"
            isSelected={weather?.includes("RAIN")}
            onCheck={() => toggleWeather("RAIN")}
          />
          <div className={styles.hairlineB} />
          <p className={styles.label}>
            Determine a faixa de horário de captura do clima
          </p>
          <div className="d-flex align-center">
            <Select
              className="w-100 mb-20"
              options={this.getTimeIntervalOptionsFrom()}
              value={time?.from}
              onChange={(e) => setTimeRange("from", e)}
            />
            <Select
              className="w-100 mb-20 ml-15"
              options={this.getTimeIntervalOptionsTo()}
              value={time?.to}
              onChange={(e) => setTimeRange("to", e)}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { visible, node, onClose, onSave } = this.props;
    const { selectedItem, payload } = this.state;

    function isInvalid() {
      if (selectedItem === "temperature") {
        if (
          payload.climate?.temperature?.min <= payload.climate?.temperature?.max
        )
          return false;
      }

      if (selectedItem === "moisture") {
        if (payload.climate?.moisture?.min <= payload.climate?.moisture?.max)
          return false;
      }

      if (selectedItem === "rain") {
        if (payload.climate?.rain?.min <= payload.climate?.rain?.max)
          return false;
      }

      return true;
    }

    return (
      <Drawer
        visible={visible}
        showBackButton={!!selectedItem}
        backButton={() => this.setState({ selectedItem: null })}
        onClose={() => onClose()}
        title={BoxTitles.SpecificClimateConditional}
        footer={
          selectedItem ? (
            <Button
              className="w-100"
              text={"Aplicar"}
              design="primary"
              onClick={() => {
                this.setState({ selectedItem: null });

                if (selectedItem === "temperature") {
                  if (
                    payload.climate?.temperature?.min <=
                    payload.climate?.temperature?.max
                  )
                    this.setClimatePayloadKeyValue("temperature", {
                      active: true,
                    });
                }

                if (selectedItem === "moisture") {
                  if (
                    payload.climate?.moisture?.min <=
                    payload.climate?.moisture?.max
                  )
                    this.setClimatePayloadKeyValue("moisture", {
                      active: true,
                    });
                }

                if (selectedItem === "rain") {
                  if (payload.climate?.rain?.min <= payload.climate?.rain?.max)
                    this.setClimatePayloadKeyValue("rain", {
                      active: true,
                    });
                }
              }}
              disabled={isInvalid()}
            />
          ) : (
            <Button
              className="w-100"
              design="primary"
              text={"Salvar"}
              onClick={() =>
                onSave({ ...node, data: { ...node.data, ...payload } })
              }
            />
          )
        }
      >
        <Switch value={selectedItem}>
          <Case value={"temperature"}>{this.renderTemperature()}</Case>
          <Case value={"moisture"}>{this.renderMoisture()}</Case>
          <Case value={"rain"}>{this.renderRain()}</Case>
          <Default>{this.renderMainPage()}</Default>
        </Switch>
      </Drawer>
    );
  }
}

const CheckCard = ({ title, isSelected, iconCls, onCheck, onOpen }) => {
  return (
    <div
      className={cssTrigger({ option: true, selected: isSelected })}
      onClick={() => onOpen && onOpen()}
    >
      <div className="d-flex align-center">
        <Checkbox checked={isSelected} onChange={onCheck} />
        <div className={triggerStyles.icon}>
          <i className={iconCls} />
        </div>
        <div className="d-flex flex-column">
          <p className={triggerStyles.type}>{title}</p>
        </div>
      </div>
      {!!onOpen && (
        <div className={triggerStyles.chevron}>
          <i className="fas fa-chevron-right" />
        </div>
      )}
    </div>
  );
};

const CheckCardWeather = ({ title, isSelected, iconCls, onCheck, onOpen }) => {
  return (
    <div
      className={cssTrigger({ option: true, selected: isSelected })}
      onClick={onCheck}
    >
      <div className="d-flex align-center">
        <Checkbox checked={isSelected} />
        <div className={triggerStyles.icon}>
          <i className={iconCls} />
        </div>
        <div className="d-flex flex-column">
          <p className={triggerStyles.type}>{title}</p>
        </div>
      </div>
      {!!onOpen && (
        <div className={triggerStyles.chevron}>
          <i className="fas fa-chevron-right" />
        </div>
      )}
    </div>
  );
};
